import { Container } from './PageMainBody.styles';

function PageMainBody({ children, style = {} }) {
  return <Container style={{ ...style }}>{children}</Container>;
}

export default PageMainBody;
